import {
  cartOptionsSelector,
  cartOptionTokensSelector,
} from '../../../../data/carts.js'
import {useSelector} from '../../../../store.js'
import FilterPanel from '../../../OrderListPage/Modals/OrderListFilterModal/FilterPanel.js'
import {
  modalFormSelector,
  SALES_CHANNEL_FILTER_PANEL,
  updateModalForm,
} from './stocktakeDetailFilterModalFunctions.js'
import {usesInventorySelector} from '../../../../data/company.js'

export default function SalesChannelFilterPanel() {
  const form = useSelector(modalFormSelector)
  const cartOptions = useSelector(cartOptionsSelector)
  const cartOptionTokens = useSelector(cartOptionTokensSelector)
  const usesInventory = useSelector(usesInventorySelector)

  if (!usesInventory) {
    return null
  }

  return (
    <FilterPanel
      id={SALES_CHANNEL_FILTER_PANEL}
      label="Sales Channels"
      searchPlaceholder="Search for a sales channel filter..."
      options={cartOptions}
      optionTokens={cartOptionTokens}
      selected={form.sales_channel}
      onSelect={(option) => {
        const sales_channel = form.sales_channel.filter(
          (id) => id !== option.value,
        )

        if (sales_channel.length === form.sales_channel.length) {
          sales_channel.push(option.value)
        }

        updateModalForm({sales_channel})
      }}
    />
  )
}
